var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotif11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24.0001,
    height: 15.9954,
    viewBox: "0 0 24.0001 15.9954",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00006 7.99767H16.0001C20.4183 7.99767 24.0001 4.41695 24.0001 0H16.0001C11.5818 0 8.00006 3.58072 8.00006 7.99767Z",
    fill: "#274766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.74574e-05 15.9953H8.00006C12.4183 15.9953 16.0001 12.4146 16.0001 7.99765H8.00006C3.58182 7.99765 5.74574e-05 11.5784 5.74574e-05 15.9953Z",
    fill: "#86905B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.5449 11.7759C17.5449 10.4508 18.6195 9.37659 19.9449 9.37659C21.2703 9.37659 22.3449 10.4508 22.3449 11.7759C22.3449 13.1009 21.2703 14.1752 19.9449 14.1752C18.6195 14.1752 17.5449 13.1009 17.5449 11.7759Z",
    fill: "#D4623A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.54488 4.05399C1.54488 2.72894 2.61944 1.65469 3.94488 1.65469C5.27032 1.65469 6.34488 2.72894 6.34488 4.05399C6.34488 5.37905 5.27032 6.45329 3.94488 6.45329C2.61944 6.45329 1.54488 5.37905 1.54488 4.05399Z",
    fill: "#86905B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotif11);
export default __webpack_public_path__ + "static/media/motif-11.90c210d6ee6ce4c4a942321ef1b601ca.svg";
export { ForwardRef as ReactComponent };